contractTypesFilter<template>
	<b-card no-body>
		<b-card-header>
			<h5 class="mb-0 text-white">
				<b>FILTROS</b>
			</h5>
		</b-card-header>
		<b-card-body class="pt-2">
			<b-row>
				<b-col
					cols="12"
					md="4"
					class="mb-2"
				>
					<label for="contractTypes">
						<strong>TIPOS DE DOCUMENTO</strong>
					</label>
					<v-select
						id="contractTypes"
						:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
						multiple
						v-model="formData.contractTypesArray"
						:options="options.contractTypes"
						placeholder="Seleccione"
						class="w-100"
						@input="changeContractTypes()"
					/>
				</b-col>

				<b-col
					cols="12"
					md="4"
					class="mb-2"
				>
					<label for="contractServices">
						<strong>TIPOS DE SERVICIO</strong>
					</label>
					<v-select
						id="contractServices"
						:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
						multiple
						v-model="formData.contractServicesArray"
						:options="options.contractServices"
						placeholder="Seleccione"
						class="w-100"
						@input="changeContractServices()"
					/>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import { ref } from "@vue/composition-api"
import vSelect from "vue-select"

export default {
	components: {
		vSelect
	},
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	setup(props, { emit }) {
		// REFS
		const formData = ref({
			contractTypesArray: [],
			contractServicesArray: []
		})

		const changeContractTypes = () => {
			if (formData.value.contractTypesArray) {
				const array = formData.value.contractTypesArray.map(
					(item) => item.value
				)
				emit("update:contractTypesFilter", array.join(","))

				return array
			}

			return null
		}

		const changeContractServices = () => {
			if (formData.value.contractServicesArray) {
				const array = formData.value.contractServicesArray.map(
					(item) => item.value
				)
				emit("update:contractServicesFilter", array.join(","))

				return array
			}

			return null
		}

		return {
			// DATA
			formData,

			// METHODS
			changeContractTypes,
			changeContractServices
		}
	}
}
</script>

<style lang="scss" scoped>
.card-header {
	background-color: var(--primary);
	padding: 1rem 1.5rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>